import type { UseAsyncCollectionResT } from '@dr.pogodin/react-global-state';
import { time } from '@dr.pogodin/react-utils';

import { getArtist } from 'services/artists';

import type { ArtistT } from 'utils';

import { useAsyncCollection } from 'utils/global-state';

type UseArtistsOptionsT = {
  disabled?: boolean;
  withAllUserDetails?: boolean;
};

type UseArtistsResT = UseAsyncCollectionResT<ArtistT>;

/**
 * Gets artist object for the specified ID.
 */
export function useArtists(
  ids: string[],
  { disabled, withAllUserDetails }: UseArtistsOptionsT = {},
): UseArtistsResT {
  return useAsyncCollection(
    ids,
    'artists.map',
    async (id) => getArtist(id, { withAllUserDetails }),
    { deps: [withAllUserDetails], disabled, maxage: time.YEAR_MS },
  );
}
